module.exports = __webpack_public_path__ + "static/media/maki-marker-stroked-15-c.5659bcc0.svg";